import React from 'react';

import { Routes } from 'react-router-dom';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring/SentryRoute';

import { Greeting } from './Greeting';
import { Login } from './Login';

export const CandidateAuth = () => {
  return (
    <Routes>
      <Route path="login" element={<Greeting />} />
      <Route path="candidate" element={<Login />} />
    </Routes>
  );
};
